<mbs-modal
  [isCustomModal]="true"
  [showFooter]="true"
  title="{{ 'shared:computers.modals:clonePlanCaption' | i18next }}"
  #modal>
  <div modal-body>
    <form
      [formGroup]="clonePlanForm"
      class="mbs-form">
      <mbs-input
        placeholder="{{ 'shared:computers.modals:clonePlanPlaceholder' | i18next }}"
        [autocomplete]="'off'"
        formControlName="cloneName"
        [validationWhitespace]="true"></mbs-input>
    </form>
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="success"
      [loading]="loading"
      (click)="handleResolve()"
      >{{ 'shared:buttons.clone' | i18next }}</mbs-button
    >
    <mbs-button
      type="secondary"
      data-dismiss="modal"
      (click)="modal.close()"
      >{{ 'shared:buttons.cancel' | i18next }}</mbs-button
    >
  </ng-container>
</mbs-modal>
